"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const TextV2_1 = require("../../foundations/Typography/TextV2");
const useId_1 = require("../../hooks/useId");
const useWarning_1 = require("../../hooks/useWarning");
const sizeMap = {
    xs: {
        container: { width: "spacing-7", height: "spacing-7" },
        iconSize: "xxs",
        padding: "spacing-2",
        fontSize: "font-size-2"
    },
    sm: {
        container: { width: "spacing-8", height: "spacing-8" },
        iconSize: "xs",
        // @ts-ignore
        padding: "6px",
        fontSize: "font-size-3"
    },
    md: {
        container: { width: "spacing-9", height: "spacing-9" },
        iconSize: "sm",
        padding: "spacing-3",
        fontSize: "font-size-4"
    },
    lg: {
        container: { width: "spacing-10", height: "spacing-10" },
        iconSize: "md",
        // @ts-ignore
        padding: "10px",
        fontSize: "font-size-6"
    }
};
const Avatar = (_a) => {
    var { size = "md", outline = false, icon, src, alt, children } = _a, props = __rest(_a, ["size", "outline", "icon", "src", "alt", "children"]);
    const { container, iconSize, padding, fontSize } = sizeMap[size];
    const { warn } = (0, useWarning_1.useWarning)();
    const id = (0, useId_1.useId)();
    if (src && !alt) {
        warn("An alt property should be passed when using an image as Avatar content.");
    }
    const role = !children ? "img" : undefined;
    const ariaLabel = !children ? alt || "User avatar" : undefined;
    const avatarIcon = icon ? icon : !children && !src ? "user" : undefined;
    const photoStyles = react_1.default.useMemo(() => ({
        backgroundImage: `url(${src})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    }), [src]);
    const outlineStyles = react_1.default.useMemo(() => ({
        outline: "1px solid",
        outlineColor: "stroke-neutral-default"
    }), []);
    const avatarStyles = react_1.default.useMemo(() => (Object.assign(Object.assign(Object.assign(Object.assign({ display: "flex", justifyContent: "center", alignItems: "center", flexShrink: 0, overflow: "hidden", whiteSpace: "nowrap", borderRadius: "radius-round" }, container), (outline && Object.assign({}, outlineStyles))), (src
        ? Object.assign({}, photoStyles) : {
        textAlign: "center",
        backgroundColor: "surface-neutral-tertiary",
        p: padding
    })), { ":focus-visible": {
            outline: "2px solid",
            outlineColor: "focus",
            outlineOffset: "2px"
        } })), [container, outline, outlineStyles, src, photoStyles, padding]);
    return (react_1.default.createElement(foundations_1.Box, { id: props.id || id, role: role, "aria-label": ariaLabel, tabIndex: 0, sx: Object.assign({}, avatarStyles) },
        !children && !src && (react_1.default.createElement(foundations_1.IconV2, { icon: avatarIcon, size: iconSize, color: "control-enabled", sx: {
                display: "flex",
                alignItems: "center"
            } })),
        !icon && !!children && (react_1.default.createElement(TextV2_1.TextV2, { variant: "body-2-medium", size: fontSize, sx: { color: "text-secondary" } }, children))));
};
exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.js.map